import React from 'react'
import styles from './Style.module.css'

export const BtnSecondaryWithIcon = ({label, handleClick, disabled, icon, customClass, variant, secondaryIcon, title}) => {
  return (
    <button 
      className={`${customClass} ${styles.Btn} ${styles.BtnSecondary} btn ${variant ? styles[variant] : ''}`}
      onClick={handleClick} 
      disabled={disabled}
      title={title || label}
    >
      <span className={`${styles.icon} ${styles.preIcon}`}>{icon}</span>
      <span className={styles.text}>{label}</span>
      <span className={`${styles.icon} ${styles.postIcon}`}>{secondaryIcon}</span>
    </button>
  )
}
